export function getUserGroups() {
  var userGroups = []
  if (sessionStorage.getItem('userGroups')) {
    userGroups = JSON.parse(sessionStorage.getItem('userGroups'))
  }
  return userGroups
}